export const OAuthResource = {
	modelYear: "modelYear",
	safetyCampaign: "safetyCampaign",
	manuals: "manuals",
	masterPreferences: "masterPreferences",
	optCodes: "optCodes",
	maintenanceScheduleDmy: "maintenanceScheduleDmy",
	maintenanceschedulevin: "maintenanceschedulevin",
	maintenanceScheduleEtd: "maintenanceScheduleEtd",
	vehicleSpecs: "vehicleSpecs",
} as const;

export type OAuthResource = (typeof OAuthResource)[keyof typeof OAuthResource];
